import { inject as service } from '@ember/service';
import Route from 'cio/routes/base';
import DS from 'ember-data';
import IntegrationModel from 'cio/models/integration';
import IntegrationsDataOutTypeModel from 'cio/models/integrations/data-out-type';
import IntegrationDataOutTypeController from 'cio/pods/integrations/data_out/type/controller';
import Transition from '@ember/routing/-private/transition';
import { action } from '@ember/object';
import ConfirmChangesService from 'cio/services/confirm-changes';

export interface DataOutTypeRouteModel {
  integration: IntegrationModel;
  dataModel: IntegrationsDataOutTypeModel;
  settings: IntegrationModel['settings'];
}

export default class IntegrationsDataOutTypeIndex extends Route {
  @service store!: DS.Store;
  @service confirmChanges!: ConfirmChangesService;

  async model(): Promise<DataOutTypeRouteModel> {
    let { type } = this.paramsFor('integrations.data_out.type') as Record<string, string>;
    this.store.unloadAll('integrations/data-out-type');
    let integrations = await this.store.findAll('integration');
    let integration = integrations.find((integration) => integration.id === type);
    let integrationSettings = integration?.get('settings');

    let dataModel;
    // api returns 200 if there is an integration and 404 if there isn't an integration
    try {
      dataModel = await this.store.findRecord('integrations/data-out-type', type, { adapterOptions: { type } });
    } catch {
      let defaultSettingsValues = integrationSettings?.reduce((acc: any, setting: any) => {
        acc[setting.key as string] = setting.type === 'boolean' ? false : '';
        return acc;
      }, {});

      dataModel = this.store.createRecord('integrations/data-out-type', {
        settings: defaultSettingsValues,
      });
    }

    return {
      integration: integration!,
      settings: integrationSettings!,
      dataModel,
    };
  }

  setupController(controller: IntegrationDataOutTypeController, model: DataOutTypeRouteModel, transition: Transition) {
    super.setupController(controller, model, transition);
    this.confirmChanges.register(controller, this);
  }

  @action
  reloadModel() {
    return this.refresh();
  }
}
